/**



 * PuraGems — Custom Product Options Web Component

 *

 * Fetches hidden "option products" by SKU, renders selectors per group type,

 * calculates running price total, and handles multi-item add-to-cart.

 *

 * Fetching strategy (per option product):

 *   1. Try /products/{handleize(sku)}.js  — works when handle matches SKU format

 *   2. Try Shopify Predictive Search API  — searches by variants.sku field

 *   3. All fetches are concurrency-limited to 4 parallel requests

 *

 * SKU format: PG-M-PXXX (e.g. PG-M-P011 → handle "pg-m-p011")

 *

 * Option group slug → selector type mapping:

 *   metal / metal_2           → color-dot swatch buttons

 *   ring_size / ring_size_2   → compact size grid (swatches)

 *   stone_size / stone_size_2 → pill buttons with price

 *   chain_length              → pill buttons (no price)

 *   side_stones / side_stones_2 / halo_stones / small_stones /

 *     surrounding_stones / bail_stones / stones → dropdown

 *   matching_band / matching_band_2             → dropdown

 *   width                                        → dropdown

 *   Loose stone groups (round/oval/cushion/etc)  → dropdown

 */







if (!customElements.get('product-custom-options')) {



  customElements.define(



    'product-custom-options',



    class ProductCustomOptions extends HTMLElement {



      constructor() {



        super();







        /** @type {Object<string,Object>} option slug → fetched product data */



        this.optionProducts = {};







        /** @type {Object<string,string>} option slug → selected variant ID */



        this.selections = {};







        /** @type {Object<string,number>} option slug → selected add-on price (cents) */



        this.selectionPrices = {};







        /** @type {number} base price in money units (e.g. 970.00) */



        this.basePrice = 0;







        this.parentVariantId = '';



        this.parentSku = '';



        this.currencySymbol = '';



        this.moneyFormat = '';







        /** Mobile display mode: 'swatch' | 'slider' | 'select' */



        this.mobileDisplay = 'swatch';



      }







      /* ─── LIFECYCLE ──────────────────────────────── */







      connectedCallback() {



        this.parentVariantId = this.dataset.parentVariantId || '';



        this.parentSku = this.dataset.parentSku || '';



        this.basePrice = parseFloat(this.dataset.basePrice) || 0;



        this.currencySymbol = this.dataset.currencySymbol || '$';



        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';







        // Read global mobile display mode from block setting



        this.mobileDisplay = this.dataset.mobileDisplay || 'swatch';







        // Detect mobile for slider mode



        this.isMobile = window.matchMedia('(max-width: 749px)').matches;



        this._resizeHandler = () => {



          this.isMobile = window.matchMedia('(max-width: 749px)').matches;



        };



        window.addEventListener('resize', this._resizeHandler);







        let optionOrder, optionSkus;



        try {



          optionOrder = this.parseMetafieldList(this.dataset.optionOrder);



        } catch (e) {



          console.error('[PuraGems] Failed to parse option order', e);



          return;



        }



        try {



          optionSkus = this.parseMetafieldList(this.dataset.optionSkus);



        } catch (e) {



          console.warn('[PuraGems] Failed to parse option SKUs', e);



          optionSkus = [];



        }







        if (!optionOrder || !optionOrder.length) {



          console.warn('[PuraGems] No option display order found');



          return;



        }



        if (!optionSkus || !optionSkus.length) {



          console.warn('[PuraGems] No option SKUs found');



          return;



        }







        console.log('[PuraGems] Initializing — order:', optionOrder, 'SKUs:', optionSkus);



        this.init(optionOrder, optionSkus);



      }







      async init(order, skus) {



        const loading = this.querySelector('.pura-options__loading');



        const container = this.querySelector('.pura-options__container');







        try {



          // Fetch all option products (concurrency limit = 4)



          const products = await this.fetchAllOptionProducts(skus, 4);







          // Map each fetched product to its display-order slug using semantic matching.



          // This prevents swaps when option_skus order != option_display_order.



          products.forEach((prod) => {



            if (!prod) return;



            const slug = this.slugFromGroupName(prod);



            if (slug && order.includes(slug) && !this.optionProducts[slug]) {



              this.optionProducts[slug] = prod;



            }



          });







          const loaded = Object.keys(this.optionProducts).length;



          console.log(`[PuraGems] Loaded ${loaded}/${order.length} option products`);







          if (loaded === 0) {



            // Show helpful diagnostic instead of hiding



            if (loading) {



              loading.innerHTML =



                '<span style="font-size:13px;color:#6A7280;">' +



                'Options could not be loaded. The option products may not be imported yet, ' +



                'or they are not published to the Online Store channel.' +



                '</span>';



            }



            console.error(



              '[PuraGems] No option products loaded. Checklist:\n' +



              '  1. Have the option products been imported to the store?\n' +



              '  2. Are they published to the Online Store sales channel?\n' +



              '     (Products MUST be on the Online Store channel for /products/handle.js to work)\n' +



              '  3. Do the product handles match the SKU format (e.g. pg-m-p011)?\n' +



              '     If not, are they at least visible in storefront search?\n' +



              '  SKUs attempted:', skus



            );



            return;



          }







          // Render each option group in display order



          container.innerHTML = '';



          order.forEach((slug) => {



            const prod = this.optionProducts[slug];



            if (!prod) return;



            const groupEl = this.renderOptionGroup(slug, prod);



            if (groupEl) container.appendChild(groupEl);



          });







          // Render price summary



          this.priceSummary = this.createPriceSummary();



          container.appendChild(this.priceSummary);







          // Show container, hide loading



          if (loading) loading.style.display = 'none';



          container.style.display = '';







          // Now that all groups are in the DOM, refresh selected text labels



          order.forEach((slug) => {



            if (!this.selections[slug]) return;



            const variantId = this.selections[slug];



            const prod = this.optionProducts[slug];



            if (!prod) return;



            const variant = (prod.variants || []).find(v => String(v.id) === String(variantId));



            if (variant) {



              this.updateSelectedText(slug, variant.title, parseInt(variant.price, 10));



            }



          });







          // Update initial price display



          this.updatePriceSummary();



          this.updateATCButton();







        } catch (err) {



          console.error('[PuraGems] Error loading options:', err);



          if (loading) {



            loading.innerHTML =



              '<span style="font-size:13px;color:#6A7280;">Error loading options. Please try refreshing the page.</span>';



          }



        }



      }







      /* ─── FETCHING ───────────────────────────────── */







      /**



       * Fetch all option products by SKU with concurrency limit.



       * @param {string[]} skus - Array of option product SKUs



       * @param {number} concurrency - Max parallel requests



       * @returns {Promise<(Object|null)[]>} Array of product data (or null)



       */



      async fetchAllOptionProducts(skus, concurrency) {



        const results = new Array(skus.length).fill(null);



        let index = 0;







        const worker = async () => {



          while (index < skus.length) {



            const i = index++;



            results[i] = await this.fetchOptionProductBySku(skus[i]);



          }



        };







        const workers = Array.from(



          { length: Math.min(concurrency, skus.length) },



          () => worker()



        );



        await Promise.all(workers);



        return results;



      }







      /**



       * Multi-tier fetch for a single option product by its SKU.



       *



       * Tier 1: Direct fetch /products/{handleize(sku)}.js



       *         Works when product handle = lowercase SKU (e.g. pg-m-p011)



       *



       * Tier 2: Shopify Predictive Search API searching by variants.sku



       *         Works when product is published & visible in search



       *



       * @param {string} sku - e.g. "PG-M-P011"



       * @returns {Promise<Object|null>}



       */



      async fetchOptionProductBySku(sku) {



        const handle = this.handleize(sku);







        /* ── Tier 1: Direct handle fetch ── */



        try {



          const resp = await fetch(



            `${window.Shopify?.routes?.root || '/'}products/${handle}.js`



          );



          if (resp.ok) {



            const data = await resp.json();



            console.log(`[PuraGems] ✓ ${sku} loaded via /products/${handle}.js`);



            return data;



          }



          console.log(`[PuraGems] ✗ /products/${handle}.js → ${resp.status}`);



        } catch (e) {



          console.warn(`[PuraGems] ✗ Fetch error for /products/${handle}.js`, e);



        }







        /* ── Tier 2: Predictive Search by variant SKU ── */



        try {



          const params = new URLSearchParams({



            q: sku,



            'resources[type]': 'product',



            'resources[limit]': '4',



            'resources[options][unavailable_products]': 'last',



            'resources[options][fields]': 'variants.sku,variants.title,title',



          });



          const searchUrl = `${window.Shopify?.routes?.root || '/'}search/suggest.json?${params}`;



          const resp = await fetch(searchUrl);







          if (resp.ok) {



            const data = await resp.json();



            const searchProducts = data?.resources?.results?.products;







            if (searchProducts && searchProducts.length > 0) {



              // Try each result — verify it actually matches our SKU



              for (const sp of searchProducts) {



                const prodHandle = sp.handle || (sp.url ? sp.url.replace(/^\/products\//, '') : null);



                if (!prodHandle) continue;







                // Fetch full product data from AJAX Product API



                const fullResp = await fetch(



                  `${window.Shopify?.routes?.root || '/'}products/${prodHandle}.js`



                );



                if (!fullResp.ok) continue;



                const fullProd = await fullResp.json();







                // Verify: at least one variant SKU starts with our SKU



                const hasMatch = fullProd.variants?.some(



                  (v) => v.sku && v.sku.toUpperCase().startsWith(sku.toUpperCase())



                );



                if (hasMatch) {



                  console.log(`[PuraGems] ✓ ${sku} loaded via search → /products/${prodHandle}.js`);



                  return fullProd;



                }



              }



            }



          }



          console.log(`[PuraGems] ✗ Search did not find a product for SKU: ${sku}`);



        } catch (e) {



          console.warn(`[PuraGems] ✗ Search error for SKU: ${sku}`, e);



        }







        console.error(



          `[PuraGems] ✗ Could not load: ${sku}. ` +



          'Ensure the product exists, is published to Online Store, ' +



          `and has handle "${handle}" or variant SKUs starting with "${sku}".`



        );



        return null;



      }







      /**



       * Robustly parse a Shopify list metafield value from a data attribute.



       * Handles double-encoding: '["[\"a\", \"b\"]"]' → ['a', 'b']



       * Also handles normal encoding: '["a", "b"]' → ['a', 'b']



       */



      parseMetafieldList(raw) {



        if (!raw) return [];



        let parsed;



        try {



          parsed = JSON.parse(raw);



        } catch {



          return [];



        }



        if (!Array.isArray(parsed)) return [];







        // Check for double-encoding: array of 1 string that is itself a JSON array



        if (parsed.length === 1 && typeof parsed[0] === 'string') {



          try {



            const inner = JSON.parse(parsed[0]);



            if (Array.isArray(inner)) return inner;



          } catch { /* not double-encoded, continue */ }



        }







        // Flatten any remaining double-encoded elements



        return parsed.flatMap((item) => {



          if (typeof item === 'string' && item.startsWith('[')) {



            try {



              const arr = JSON.parse(item);



              if (Array.isArray(arr)) return arr;



            } catch { /* not JSON */ }



          }



          return [item];



        });



      }







      /**



       * Convert a string to a Shopify-compatible handle.



       * "PG-M-P011" → "pg-m-p011"



       */



      handleize(str) {



        return String(str)



          .toLowerCase()



          .replace(/[^a-z0-9]+/g, '-')



          .replace(/(^-|-$)/g, '');



      }







      /**



       * Derive a slug from the product's metafield or title.



       */



      slugFromProduct(prod) {



        // Use the option_group metafield if available



        if (prod.metafields && prod.metafields.custom && prod.metafields.custom.option_group) {



          return this.slugify(prod.metafields.custom.option_group);



        }



        // Fallback: derive from title "PuraGems - Metal" → "metal"



        const title = prod.title || '';



        const clean = title.replace(/^PuraGems\s*[-–—]\s*/i, '').replace(/\(V\d+\)/gi, '').trim();



        return this.slugify(clean);



      }







      /**



       * Map a fetched option product to its display-order slug using the product's first option name.



       * Prevents Metal <-> Matching Band swaps caused by order mismatches in metafields.



       * prod.options[0] (e.g. "Metal", "Choose Matching Band") --> display slug.



       */



      slugFromGroupName(prod) {



        const GROUP_NAME_TO_SLUG = {



          'Stone Size':                   'stone_size',



          'Select Your Stone Size':       'stone_size',



          'Select Your Stone Size-2':     'stone_size',



          'Side Stones':                  'side_stones',



          'Select Your Side Stones':      'side_stones',



          'Select Your Side Stones-2':    'side_stones',



          'Select Your Small Stones':     'side_stones',



          'Select Your Halo Stones':      'side_stones',



          'Select Surrounding Stones':    'side_stones',



          'Select Your Bail Stones':      'side_stones',



          'Select Your Stones':           'side_stones',



          'Metal':                        'metal',



          'Metal-2':                      'metal_2',



          'Ring Size':                    'ring_size',



          'Ring Size-2':                  'ring_size_2',



          'Chain Length':                 'chain_length',



          'Select Your Width':            'band_width',



          'Choose Matching Band':         'matching_band',



          'Choose Matching Band-2':       'matching_band_2',



          'Round Cut Loose Moissanite':   'round_cut_loose_moissanite',



          'Oval Cut Loose Moissanite':    'oval_cut_loose_moissanite',



          'Cushion Cut Loose Moissanite': 'cushion_cut_loose_moissanite',



          'Princess Loose Moissanite':    'princess_loose_moissanite',



          'Emerald Cut Loose Moissanite': 'emerald_cut_loose_moissanite',



        };



        // prod.options[0] is a string on Shopify AJAX API; handle object form too



        const opt = prod.options && prod.options[0];



        const optName = (opt && typeof opt === 'object') ? opt.name : opt;



        if (optName && GROUP_NAME_TO_SLUG[optName]) return GROUP_NAME_TO_SLUG[optName];



        // Fallback: strip vendor prefix + version suffix from title



        const clean = (prod.title || '').replace(/^PuraGems\s*[-–—]\s*/i, '').replace(/\s*\(V\d+\)\s*/gi, '').trim();



        return GROUP_NAME_TO_SLUG[clean] || null;



      }



      slugify(str) {



        return str



          .toLowerCase()



          .replace(/[^a-z0-9]+/g, '_')



          .replace(/^_|_$/g, '');



      }







      /**



       * Determine the selector type for a given option group slug.



       */



      getSelectorType(slug) {



        if (/^metal/.test(slug)) return 'metal';



        if (/^ring_size/.test(slug)) return 'size';



        if (/^stone_size/.test(slug)) return 'pill';



        if (/^chain_length/.test(slug)) return 'pill';



        // Everything else gets a dropdown



        return 'dropdown';



      }







      isStonesGroup(slug) {



        return /^side_stones|^select_your_|^select_surrounding/.test(slug);



      }







      normalizeStoneValue(slug, title) {



        if (this.isStonesGroup(slug)) {



          if (title === 'Diamond' || title.startsWith('Diamond ')) return 'Lab ' + title;



          return title;



        }



        if (slug === 'matching_band' || slug === 'matching_band_2') {



          return title.replace(/, Diamond\b/, ', Lab Diamond');



        }



        return title;



      }







      /**



       * Get the display mode for a given slug.



       * On mobile, returns the global mobile_display setting.



       * On desktop, always returns 'swatch' (native swatches).



       * Dropdown types are never overridden.



       */



      getDisplayMode(slug) {



        const type = this.getSelectorType(slug);



        if (type === 'dropdown') return 'swatch'; // dropdowns stay as dropdowns



        if (this.isMobile) return this.mobileDisplay || 'swatch';



        return 'swatch'; // desktop always uses native swatches



      }







      /**



       * Get a human-readable label for an option group slug.



       */



      getGroupLabel(slug) {



        const labels = {



          stone_size: 'Stone Size',



          stone_size_2: 'Stone Size (2nd Ring)',



          side_stones: 'Choose Side Stones',



          side_stones_2: 'Choose Side Stones (2nd Ring)',



          matching_band: 'Choose Matching Band',



          matching_band_2: 'Choose Matching Band (2nd Ring)',



          metal: 'Metal',



          metal_2: 'Metal (2nd Ring)',



          ring_size: 'Ring Size',



          ring_size_2: 'Ring Size (2nd Ring)',



          chain_length: 'Chain Length',



          select_your_stones: 'Choose Stones',



          select_your_width: 'Width',



          select_your_halo_stones: 'Choose Halo Stones',



          select_your_small_stones: 'Choose Small Stones',



          select_surrounding_stones: 'Choose Surrounding Stones',



          select_your_bail_stones: 'Choose Bail Stones',



          round_cut_loose_moissanite: 'Round Cut Loose Moissanite',



          oval_cut_loose_moissanite: 'Oval Cut Loose Moissanite',



          cushion_cut_loose_moissanite: 'Cushion Cut Loose Moissanite',



          princess_loose_moissanite: 'Princess Loose Moissanite',



          emerald_cut_loose_moissanite: 'Emerald Cut Loose Moissanite',



        };



        return labels[slug] || slug.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());



      }







      // ──── RENDERERS ──────────────────────────────────────







      renderOptionGroup(slug, prod) {



        const type = this.getSelectorType(slug);



        const displayMode = this.getDisplayMode(slug);



        const label = this.getGroupLabel(slug);



        let variants = prod.variants || [];



        // Lab Diamond option products: only show the free side-stone variant



        if (this.isStonesGroup(slug) && /^pg-ld-/.test(prod.handle || '')) {



          const free = variants.filter(v => parseInt(v.price, 10) === 0);



          if (free.length > 0) variants = free;



        }



        if (this.isStonesGroup(slug) && variants.length === 1) {



          this.setSelection(slug, variants[0].id, variants[0].price, variants[0].title);



          const staticGroup = document.createElement('div');



          staticGroup.className = 'pura-option-group';



          staticGroup.dataset.slug = slug;



          const staticLabel = document.createElement('p');



          staticLabel.className = 'pura-option-group__label';



          staticLabel.textContent = label.replace(/^Choose\s+/i, '');



          const staticValue = document.createElement('span');



          staticValue.className = 'pura-option-group__static-value';



          staticValue.style.color = '#999999';



          staticValue.style.fontWeight = '400';



          staticValue.textContent = this.normalizeStoneValue(slug, variants[0].title);



          staticLabel.appendChild(document.createTextNode(' \u2014 '));



          staticLabel.appendChild(staticValue);



          staticGroup.appendChild(staticLabel);



          return staticGroup;



        }







        const group = document.createElement('div');



        group.className = 'pura-option-group';



        group.dataset.slug = slug;







        // Label row



        const labelEl = document.createElement('p');



        labelEl.className = 'pura-option-group__label';



        labelEl.innerHTML = `${label} <span class="pura-option-group__label-selected" data-selected-text></span>`;



        group.appendChild(labelEl);







        // If display mode is "select" and type is not already dropdown, render as select



        if (displayMode === 'select' && type !== 'dropdown') {



          const selectorEl = this.renderSelectBoxSelector(slug, variants, type);



          group.appendChild(selectorEl);



          return group;



        }







        // If display mode is "slider" and mobile, wrap in slider



        const useSlider = displayMode === 'slider' && this.isMobile && type !== 'dropdown';







        // Selector



        let selectorEl;



        switch (type) {



          case 'metal':



            selectorEl = this.renderMetalSelector(slug, variants);



            break;



          case 'size':



            selectorEl = this.renderSizeSelector(slug, variants);



            break;



          case 'pill':



            selectorEl = this.renderPillSelector(slug, variants);



            break;



          default:



            selectorEl = this.renderDropdownSelector(slug, variants);



        }







        if (useSlider) {



          const sliderEl = this.wrapInSlider(selectorEl, type);



          group.appendChild(sliderEl);



        } else {



          group.appendChild(selectorEl);



        }







        return group;



      }







      /**



       * Metal swatches — compact color dot + abbreviated karat label,



       * with hover tooltip showing full metal name + price.



       */



      renderMetalSelector(slug, variants) {



        const wrap = document.createElement('div');



        wrap.className = 'pura-metal-opts';



        wrap.setAttribute('role', 'radiogroup');







        variants.forEach((v, i) => {



          const btn = document.createElement('button');



          btn.type = 'button';



          btn.className = 'pura-metal-opt pura-metal-opt--compact';



          btn.setAttribute('role', 'radio');



          btn.setAttribute('aria-checked', i === 0 ? 'true' : 'false');



          btn.dataset.variantId = v.id;



          btn.dataset.price = v.price;



          btn.dataset.title = v.title;







          const dotClass = this.getMetalDotClass(v.title);



          const priceStr = v.price > 0 ? `+${this.formatMoney(v.price)}` : 'Included';



          const abbrev = this.getMetalAbbrev(v.title);







          btn.innerHTML = `



            <span class="pura-metal-dot ${dotClass}"></span>



            <span class="pura-metal-opt__abbrev">${this.escapeHtml(abbrev)}</span>



            <span class="pura-tooltip" role="tooltip">



              <span class="pura-tooltip__line">${this.escapeHtml(v.title)}</span>



              <span class="pura-tooltip__line">${priceStr}</span>



            </span>



          `;







          btn.addEventListener('click', () => this.selectOption(slug, btn, wrap));



          wrap.appendChild(btn);



        });







        // Auto-select first



        if (variants.length > 0) {



          this.setSelection(slug, variants[0].id, variants[0].price, variants[0].title);



        }







        return wrap;



      }







      /**



       * Abbreviate metal titles for compact display.



       * "10kt White Gold" → "10K", "14kt Rose Gold" → "14K", "Platinum" → "PL"



       */



      getMetalAbbrev(title) {



        const t = title.toLowerCase();



        // Platinum variants show full title (e.g. "Platinum, Diamond")



        if (t.includes('platinum')) return title;



        // Match karat patterns



        const karatMatch = t.match(/(\d+)\s*k(?:t|ar)?/);



        if (karatMatch) return karatMatch[1] + 'K';



        if (t.includes('silver') || t.includes('sterling')) return 'SS';



        // Fallback: first 3 chars



        return title.substring(0, 3).toUpperCase();



      }







      getMetalDotClass(title) {



        const t = title.toLowerCase();



        if (t.includes('rose')) return 'pura-metal-dot--rose-gold';



        if (t.includes('white')) return 'pura-metal-dot--white-gold';



        if (t.includes('platinum')) return 'pura-metal-dot--platinum';



        if (t.includes('silver') || t.includes('sterling')) return 'pura-metal-dot--silver';



        if (t.includes('yellow')) return 'pura-metal-dot--yellow-gold';



        if (t.includes('gold')) return 'pura-metal-dot--yellow-gold';



        return 'pura-metal-dot--neutral';



      }







      /**



       * Ring size grid — compact numbered buttons



       */



      renderSizeSelector(slug, variants) {



        const frag = document.createElement('div');







        const wrap = document.createElement('div');



        wrap.className = 'pura-size-opts';



        wrap.setAttribute('role', 'radiogroup');







        variants.forEach((v, i) => {



          const btn = document.createElement('button');



          btn.type = 'button';



          btn.className = 'pura-size-opt';



          btn.setAttribute('role', 'radio');



          btn.setAttribute('aria-checked', i === 0 ? 'true' : 'false');



          btn.dataset.variantId = v.id;



          btn.dataset.price = v.price;



          btn.dataset.title = v.title;



          btn.textContent = v.title;







          btn.addEventListener('click', () => this.selectOption(slug, btn, wrap));



          wrap.appendChild(btn);



        });







        frag.appendChild(wrap);







        // Size guide link



        const link = document.createElement('a');



        link.className = 'pura-size-link';



        link.href = '/pages/ring-size-guide';



        link.textContent = 'Ring Size Guide →';



        frag.appendChild(link);







        // Auto-select first



        if (variants.length > 0) {



          this.setSelection(slug, variants[0].id, variants[0].price, variants[0].title);



        }







        return frag;



      }







      /**



       * Pill buttons — for stone sizes, chain lengths



       * Stone sizes show compact carat label with hover tooltip for full details.



       */



      renderPillSelector(slug, variants) {



        const wrap = document.createElement('div');



        wrap.className = 'pura-pill-opts';



        wrap.setAttribute('role', 'radiogroup');







        const isStoneSize = /^stone_size/.test(slug);







        variants.forEach((v, i) => {



          const btn = document.createElement('button');



          btn.type = 'button';



          btn.className = 'pura-pill-opt';



          btn.setAttribute('role', 'radio');



          btn.setAttribute('aria-checked', i === 0 ? 'true' : 'false');



          btn.dataset.variantId = v.id;



          btn.dataset.price = v.price;



          btn.dataset.title = v.title;







          const priceStr = v.price > 0 ? `+${this.formatMoney(v.price)}` : 'Included';







          if (isStoneSize) {



            // Extract compact carat label & dimension from title



            // Typical title: "0.75ct (6.5 x 5mm)" or "1.00ct (7 x 5mm)"



            const parsed = this.parseStoneTitle(v.title);



            btn.classList.add('pura-pill-opt--compact');



            btn.innerHTML = `${this.escapeHtml(parsed.carat)}`;







            // Build tooltip content



            const tooltipLines = [];



            if (parsed.dimensions) tooltipLines.push(parsed.dimensions);



            tooltipLines.push(priceStr);



            const tooltip = document.createElement('span');



            tooltip.className = 'pura-tooltip';



            tooltip.setAttribute('role', 'tooltip');



            tooltip.innerHTML = tooltipLines.map(l => `<span class="pura-tooltip__line">${this.escapeHtml(l)}</span>`).join('');



            btn.appendChild(tooltip);



          } else {



            btn.innerHTML = `



              ${this.escapeHtml(v.title)}



              <span class="pura-pill-opt__price">${priceStr}</span>



            `;



          }







          btn.addEventListener('click', () => this.selectOption(slug, btn, wrap));



          wrap.appendChild(btn);



        });







        // Auto-select first



        if (variants.length > 0) {



          this.setSelection(slug, variants[0].id, variants[0].price, variants[0].title);



        }







        return wrap;



      }







      /**



       * Parse a stone size title like "0.75ct (6.5 x 5mm)" into parts.



       */



      parseStoneTitle(title) {



        const match = title.match(/^([\d.]+\s*ct)\s*\((.+)\)$/i);



        if (match) {



          return { carat: match[1].trim(), dimensions: match[2].trim() };



        }



        // Fallback: if title matches just carat pattern



        const caratMatch = title.match(/^([\d.]+\s*ct)/i);



        if (caratMatch) {



          return { carat: caratMatch[1].trim(), dimensions: '' };



        }



        return { carat: title, dimensions: '' };



      }







      /**



       * Dropdown selector — for side stones, matching band, width, etc.



       */



      renderDropdownSelector(slug, variants) {



        const wrap = document.createElement('div');



        wrap.className = 'pura-dropdown-wrap';







        const select = document.createElement('select');



        select.className = 'pura-dropdown';



        select.dataset.slug = slug;



        select.setAttribute('aria-label', this.getGroupLabel(slug));







        // Placeholder



        const placeholder = document.createElement('option');



        placeholder.value = '';



        placeholder.textContent = `Select ${this.getGroupLabel(slug)}`;



        placeholder.disabled = true;



        select.appendChild(placeholder);







        variants.forEach((v, i) => {



          const opt = document.createElement('option');



          opt.value = v.id;



          opt.dataset.price = v.price;



          opt.dataset.title = v.title;







          const priceStr = v.price > 0 ? ` (+${this.formatMoney(v.price)})` : '';



          opt.textContent = `${this.normalizeStoneValue(slug, v.title)}${priceStr}`;







          if (i === 0) opt.selected = true;



          select.appendChild(opt);



        });







        select.addEventListener('change', () => {



          const opt = select.options[select.selectedIndex];



          if (opt && opt.value) {



            this.setSelection(slug, opt.value, parseInt(opt.dataset.price || '0', 10), opt.dataset.title);



            this.updateSelectedText(slug, opt.dataset.title, parseInt(opt.dataset.price || '0', 10));



            this.updatePriceSummary();



            this.updateATCButton();



          }



        });







        wrap.appendChild(select);







        // Auto-select first



        if (variants.length > 0) {



          this.setSelection(slug, variants[0].id, variants[0].price, variants[0].title);



        }







        return wrap;



      }







      /**



       * Select box renderer — converts any swatch type to a <select> dropdown.



       * Used when user sets display mode to "select" in theme settings.



       */



      renderSelectBoxSelector(slug, variants, originalType) {



        const wrap = document.createElement('div');



        wrap.className = 'pura-select-wrap';







        const select = document.createElement('select');



        select.className = 'pura-select';



        select.dataset.slug = slug;



        select.setAttribute('aria-label', this.getGroupLabel(slug));







        variants.forEach((v, i) => {



          const opt = document.createElement('option');



          opt.value = v.id;



          opt.dataset.price = v.price;



          opt.dataset.title = v.title;







          let label = v.title;



          if (v.price > 0) {



            label += ` (+${this.formatMoney(v.price)})`;



          } else if (originalType === 'pill') {



            label += ' (Included)';



          }



          opt.textContent = label;



          if (i === 0) opt.selected = true;



          select.appendChild(opt);



        });







        select.addEventListener('change', () => {



          const opt = select.options[select.selectedIndex];



          if (opt && opt.value) {



            this.setSelection(slug, opt.value, parseInt(opt.dataset.price || '0', 10), opt.dataset.title);



            this.updateSelectedText(slug, opt.dataset.title, parseInt(opt.dataset.price || '0', 10));



            this.updatePriceSummary();



            this.updateATCButton();



          }



        });







        wrap.appendChild(select);







        // Auto-select first



        if (variants.length > 0) {



          this.setSelection(slug, variants[0].id, variants[0].price, variants[0].title);



        }







        // Add size guide link for ring sizes



        if (/^ring_size/.test(slug)) {



          const link = document.createElement('a');



          link.className = 'pura-size-link';



          link.href = '/pages/ring-size-guide';



          link.textContent = 'Ring Size Guide →';



          wrap.appendChild(link);



        }







        return wrap;



      }







      /**



       * Wraps a swatch element in a horizontal slider container for mobile.



       * On desktop the slider chrome is hidden via CSS and swatches wrap normally.



       */



      wrapInSlider(selectorEl, type) {



        const sliderWrap = document.createElement('div');



        sliderWrap.className = 'pura-slider-wrap';







        // Find the actual swatch container (may be nested in a fragment for sizes)



        let swatchContainer;



        if (type === 'size') {



          // Size selector returns a fragment with .pura-size-opts + link



          swatchContainer = selectorEl.querySelector('.pura-size-opts');



          if (!swatchContainer) swatchContainer = selectorEl;



        } else {



          swatchContainer = selectorEl;



        }







        // Move swatch items into slider track



        const track = document.createElement('div');



        track.className = 'pura-slider-track';







        // Re-parent children



        while (swatchContainer.firstChild) {



          track.appendChild(swatchContainer.firstChild);



        }







        sliderWrap.appendChild(track);







        // Arrows



        const arrows = document.createElement('div');



        arrows.className = 'pura-slider-arrows';



        arrows.innerHTML = `



          <button type="button" class="pura-slider-arrow pura-slider-arrow--prev" aria-label="Scroll left">



            <svg viewBox="0 0 12 12"><polyline points="4 1 9 6 4 11"/></svg>



          </button>



          <button type="button" class="pura-slider-arrow pura-slider-arrow--next" aria-label="Scroll right">



            <svg viewBox="0 0 12 12"><polyline points="4 1 9 6 4 11"/></svg>



          </button>



        `;



        sliderWrap.appendChild(arrows);







        // Wire up arrow clicks



        const prevBtn = arrows.querySelector('.pura-slider-arrow--prev');



        const nextBtn = arrows.querySelector('.pura-slider-arrow--next');



        const scrollAmount = 200;







        prevBtn.addEventListener('click', () => {



          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });



        });



        nextBtn.addEventListener('click', () => {



          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });



        });







        // If original element had extra children (like the size guide link), add them after



        if (type === 'size') {



          const link = selectorEl.querySelector('.pura-size-link');



          if (link) {



            sliderWrap.appendChild(link);



          }



        }







        return sliderWrap;



      }







      // ──── PRICE SUMMARY ──────────────────────────────







      createPriceSummary() {



        const div = document.createElement('div');



        div.className = 'pura-price-summary';



        div.setAttribute('aria-live', 'polite');



        return div;



      }







      updatePriceSummary() {



        if (!this.priceSummary) return;







        let html = '';



        let totalAddon = 0;







        // Base price row



        html += `



          <div class="pura-price-summary__row">



            <span class="pura-price-summary__row--label">Base Price</span>



            <span class="pura-price-summary__row--value">${this.formatMoney(this.basePrice * 100)}</span>



          </div>



        `;







        // Each selected option



        const order = Object.keys(this.optionProducts);



        order.forEach((slug) => {



          const price = this.selectionPrices[slug] || 0;



          if (price > 0) {



            totalAddon += price;



            html += `



              <div class="pura-price-summary__row">



                <span class="pura-price-summary__row--label">${this.getGroupLabel(slug)}</span>



                <span class="pura-price-summary__row--value">+${this.formatMoney(price)}</span>



              </div>



            `;



          }



        });







        // Total



        const total = (this.basePrice * 100) + totalAddon;



        html += `



          <div class="pura-price-summary__total">



            <span class="pura-price-summary__total-label">Total</span>



            <span class="pura-price-summary__total-value">${this.formatMoney(total)}</span>



          </div>



        `;







        this.priceSummary.innerHTML = html;







        // Sync the main product price block (sale + compare-at) with the new total.



        this.updateMainPrice(total);



        this.updateKlarnaMessage(total);



      }







      /**



       * Update the main product-info price block so the displayed sale price



       * (and strikethrough compare-at price) reflect the current base + add-on total.



       *



       * The compare-at price is scaled by the ratio captured on first render,



       * so the original discount percentage is preserved across selections.



       *



       * @param {number} totalCents - running total in cents



       */



      updateMainPrice(totalCents) {



        const productInfo = this.closest('product-info');



        if (!productInfo) return;







        const priceBlock = productInfo.querySelector('.price');



        if (!priceBlock) return;







        // Capture the compare-at / price ratio once on first run.



        if (this._compareRatio == null) {



          let ratio = 1;



          const compareEl = priceBlock.querySelector('.price__sale .price-item--regular, .price__regular .variant-item__old-price');



          const saleEl = priceBlock.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');



          const parseAmount = (el) => {



            if (!el) return 0;



            const txt = (el.textContent || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');



            return parseFloat(txt) || 0;



          };



          const compareVal = parseAmount(compareEl);



          const saleVal = parseAmount(saleEl);



          if (compareVal > 0 && saleVal > 0 && compareVal > saleVal) {



            ratio = compareVal / saleVal;



          }



          this._compareRatio = ratio;



        }







        const saleFormatted = this.formatMoney(totalCents);







        // Update the sale (live) price — covers both .price__sale and .price__regular layouts.



        priceBlock.querySelectorAll(



          '.price__sale .price-item--sale, .price__regular .price-item--regular'



        ).forEach((el) => {



          el.textContent = saleFormatted;



        });







        // Update the strikethrough compare-at price if we have a ratio.



        if (this._compareRatio > 1) {



          const compareCents = Math.round(totalCents * this._compareRatio);



          const compareFormatted = this.formatMoney(compareCents);



          priceBlock.querySelectorAll(



            '.price__sale .price-item--regular, .price__regular .variant-item__old-price'



          ).forEach((el) => {



            el.textContent = compareFormatted;



          });



        }



      }



      /**

       * Update the custom Klarna "4 interest-free payments" message below

       * Add to cart so it reflects the current base + add-on total, not just

       * the base variant price.

       *

       * @param {number} totalCents - running total in cents

       */

      updateKlarnaMessage(totalCents) {

        if (typeof window === 'undefined' || !window.klarnaAppBlocksManager) return;

        clearTimeout(this._klarnaPushTimer);

        this._klarnaPushTimer = setTimeout(() => {

          const placement = document.querySelector('klarna-placement[data-key="top-strip-promotion-auto-size"]');

          if (!placement || !placement.id) return;

          const productInfo = this.closest('product-info');

          const variantInput = productInfo ? productInfo.querySelector('input[name="id"], select[name="id"]') : null;

          const variantId = variantInput ? Number.parseInt(variantInput.value, 10) : 0;

          window.klarnaAppBlocksManager.push({

            productVariants: [{ id: variantId, price: totalCents, available: true }],

            templateName: 'product',

            dataKey: 'top-strip-promotion-auto-size',

            storefrontCurrency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',

            storefrontCountry: 'US',

            storefrontLanguage: 'en',

            shopLocale: 'en',

            shopDomain: window.Shopify ? window.Shopify.shop : window.location.hostname,

            variantPrice: String(totalCents),

            cartPrice: '0',

            selector: placement.id,

            topPadding: '0',

            bottomPadding: '0',

          });

        }, 350);

      }







      // ──── SELECTION LOGIC ────────────────────────────







      selectOption(slug, btn, container) {



        // Deselect all siblings



        container.querySelectorAll('[role="radio"]').forEach((el) => {



          el.setAttribute('aria-checked', 'false');



        });



        btn.setAttribute('aria-checked', 'true');







        const variantId = btn.dataset.variantId;



        const price = parseInt(btn.dataset.price || '0', 10);



        const title = btn.dataset.title || '';







        this.setSelection(slug, variantId, price, title);



        this.updateSelectedText(slug, title, price);



        this.updatePriceSummary();



        this.updateATCButton();



      }







      setSelection(slug, variantId, price, title) {



        this.selections[slug] = variantId;



        this.selectionPrices[slug] = parseInt(price, 10);



        this.updateSelectedText(slug, title, parseInt(price, 10));



      }







      updateSelectedText(slug, title, price) {



        const group = this.querySelector(`.pura-option-group[data-slug="${slug}"]`);



        if (!group) return;



        const textEl = group.querySelector('[data-selected-text]');



        if (!textEl) return;







        const priceStr = price > 0 ? `(+${this.formatMoney(price)})` : '';



        textEl.textContent = priceStr;



      }







      // ──── ATC BUTTON ─────────────────────────────────







      updateATCButton() {



        const totalCents = this.getTotal();



        const formattedTotal = this.formatMoney(totalCents);







        // Find the submit button in the parent product-info



        const productInfo = this.closest('product-info');



        if (!productInfo) return;







        const submitBtn = productInfo.querySelector('.product-form__submit span');



        if (submitBtn) {



          submitBtn.textContent = `Add to Bag — ${formattedTotal}`;



        }



      }







      getTotal() {



        let total = this.basePrice * 100; // convert to cents



        Object.values(this.selectionPrices).forEach((p) => {



          total += p;



        });



        return total;



      }







      // ──── CART INTEGRATION ───────────────────────────







      /**



       * Called by the modified product-form.js to get all cart line items.



       * Returns an array of { id, quantity, properties } objects.



       */



      getCartItems(quantity = 1) {



        const items = [];







        // PuraGems: unique bundle ID ties this exact parent + children together



        const bundleId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);







        // 1. Parent product



        items.push({



          id: parseInt(this.parentVariantId, 10),



          quantity: quantity,



          properties: {



            _bundle: 'parent',



            _parent_sku: this.parentSku,



            _bundle_id: bundleId,



          },



        });







        // 2. Each selected option variant



        Object.entries(this.selections).forEach(([slug, variantId]) => {



          if (!variantId) return;



          items.push({



            id: parseInt(variantId, 10),



            quantity: quantity,



            properties: {



              _bundle: 'option',



              _parent_sku: this.parentSku,



              _bundle_id: bundleId,



              _option_group: slug,



                          _tracking_exclude: 'true',
},



          });



        });







        return items;



      }







      /**



       * Checks if all option groups have been selected.



       */



      isComplete() {



        const slugs = Object.keys(this.optionProducts);



        return slugs.every((slug) => !!this.selections[slug]);



      }







      /**



       * Show/hide validation error.



       */



      showError(show = true) {



        const err = this.querySelector('.pura-options__error');



        if (err) err.classList.toggle('is-visible', show);



      }







      // ──── UTILITIES ──────────────────────────────────







      /**



       * Format price from cents to display string.



       * Uses the shop money format.



       */



      formatMoney(cents) {



        const amountNum = cents / 100;



        // Two-decimal format with thousands separators: 1220 → "1,220.00"



        const amount = amountNum.toLocaleString('en-US', {



          minimumFractionDigits: 2,



          maximumFractionDigits: 2,



        });



        const amountNoDecimals = Math.floor(cents / 100).toLocaleString('en-US');



        // European format: 1220.00 → "1.220,00"



        const amountWithComma = amountNum



          .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });







        let formatted = this.moneyFormat || '${{amount}}';



        formatted = formatted



          .replace('{{amount_no_decimals}}', amountNoDecimals)



          .replace('{{amount_with_comma_separator}}', amountWithComma)



          .replace('{{amount}}', amount);







        return formatted;



      }







      escapeHtml(str) {



        const div = document.createElement('div');



        div.textContent = str;



        return div.innerHTML;



      }



    }



  );



}



